import React from 'react';
import { ArrowRight, Monitor, Shield, Clock, ExternalLink } from 'lucide-react';

export default function RemoteSupport() {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="max-w-3xl">
            <h1 className="text-4xl font-bold mb-6">Remote Support</h1>
            <p className="text-xl text-blue-100 mb-8">
              Get immediate technical assistance from our expert support team, no matter where you are.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="tel:844-219-3935"
                className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                <Clock className="mr-2 h-5 w-5" />
                24/7 Support: 844-219-3935
              </a>
              <a
                href="mailto:support@ucx.co"
                className="inline-flex items-center px-6 py-3 border-2 border-white text-white rounded-lg hover:bg-white hover:text-blue-900 transition-colors"
              >
                Email Support
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Remote Support Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
          <div className="flex items-center mb-6">
            <div className="bg-blue-50 p-3 rounded-lg text-blue-600 mr-4">
              <Monitor className="h-6 w-6" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Remote Support Portal</h2>
              <p className="text-gray-600">Connect with our technical team for immediate assistance</p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 mb-8">
            <div className="flex items-start">
              <div className="bg-blue-50 p-2 rounded-lg text-blue-600 mr-3">
                <Shield className="h-5 w-5" />
              </div>
              <p className="text-sm text-gray-600">
                This is a secure connection to our remote support system. Our technicians will only connect with your explicit permission.
              </p>
            </div>
          </div>

          <div className="flex justify-center">
            <a
              href="https://rmmus-unifiedconnexions.screenconnect.com/?Theme=Embedded"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors group"
            >
              <Monitor className="mr-2 h-5 w-5" />
              Launch Remote Support Portal
              <ExternalLink className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}